var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', {
    staticClass: "skip-links list-unstyled mb-0 p-1 justify-content-center d-none d-lg-flex",
    class: {
      'sr-only': _vm.hideNavigation
    },
    attrs: {
      "aria-hidden": "false"
    }
  }, _vm._l(_vm.skipLinks, function (skipLink, index) {
    return _c('li', {
      key: index,
      staticClass: "skip-link"
    }, [_c('mdm-skip-to', {
      attrs: {
        "to": skipLink.to
      },
      domProps: {
        "textContent": _vm._s(skipLink.text)
      }
    })], 1);
  }), 0);
};
var staticRenderFns = [];
export { render, staticRenderFns };